<template>
    <div>

        <!-- Título / Breadcrumbs / Botões -->
        <mu-row justify-content="center" align-items="center">
            <mu-col span="6" sm="6" md="6" lg="6" xl="6">

                <!-- Título da página -->
                <mu-title color="secondary" textStrong="700">Relatórios</mu-title>

                <!-- Breadcrumbs -->
                <mu-breadcrumbs divider="—">
                    <font-awesome-icon icon="chevron-right" slot="divider" class="icon-sm icon-margin-right"/>
                    <mu-breadcrumbs-item v-for="item in breadcrumbs" :key="item.text" :to="{ name: item.route }" :disabled="item.disabled">{{ item.text }}</mu-breadcrumbs-item>
                </mu-breadcrumbs>
            </mu-col>
            <mu-col span="6" sm="6" md="6" lg="6" xl="6" class="is-right">

                <!-- Submenu -->
                <mu-submenu :submenu="submenu"></mu-submenu>
            </mu-col>
        </mu-row>

        <br>

        <div class="alert-message">
            <mu-row>
                <mu-col span="6" sm="6" md="6" lg="6" xl="6">
                    Obs.: Os relatórios expiram em 3 dias.
                    <div class="legend">
                        <strong>Status:</strong>
                        <mu-circular-progress color="gray" :stroke-width="1" :size="14"></mu-circular-progress> Processando
                        <mu-dot color="grey"></mu-dot> Fila para processamento
                        <mu-dot color="green"></mu-dot> Arquivo gerado com sucesso
                        <mu-dot color="red"></mu-dot> Ocorreu um problema
                    </div>
                </mu-col>
                <mu-col span="6" sm="6" md="6" lg="6" xl="6" class="is-right">
                    <mu-button color="#ccc" textColor="#666" round small @click="load()"><font-awesome-icon icon="sync-alt" /> Atualizar listagem</mu-button>
                </mu-col>
            </mu-row>
        </div>

        <br>

        <!-- Formulário para importar contatos -->
        <div class="reports" v-if="!reports.loading">
            <mu-paper :z-depth="1">

                <!-- Listagem dos grupos -->
                <mu-data-table :columns="reports.columns" :data="reports.list" class="mu-table-custom">
                    <template slot="empty">
                        <div class="box-table-empty">
                            Não foi encontrado registros.
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <td>
                            <div v-if="scope.row.generate_at">
                                {{ dateFormat(scope.row.generate_at, true) }}
                            </div>
                        </td>
                        <td>{{ scope.row.nick_name }}</td>
                        <td>{{ scope.row.title }}</td>
                        <td>{{ scope.row.service }}</td>
                        <td>{{ dateFormat(scope.row.start_at, false) }} até {{ dateFormat(scope.row.end_at, false) }}</td>
                        <td class="is-center">
                            <a href="javascript:;" @click="downloadFile(scope.row)" v-if="scope.row.status == 2">
                                <font-awesome-icon icon="download" class="icon-size" />
                            </a>
                        </td>
                        <td class="is-center">
                            <div v-if="scope.row.status == 0">
                                <mu-dot color="grey"></mu-dot>
                            </div>
                            <div v-else-if="scope.row.status == 1">
                                <mu-circular-progress color="gray" :stroke-width="1" :size="14"></mu-circular-progress>
                            </div>
                            <div v-else-if="scope.row.status == 2">
                                <mu-dot color="green"></mu-dot>
                            </div>
                            <div v-else-if="scope.row.status == 3">
                                <mu-dot color="red"></mu-dot>
                            </div>
                        </td>
                    </template>
                </mu-data-table>
            </mu-paper>

            <!-- Paginação -->
            <mu-flex class="paginate" justify-content="center" v-if="reports.paging.total > reports.paging.size">
                <mu-pagination :total="reports.paging.total" :page-count="5" :page-size="reports.paging.size" :current.sync="reports.paging.page" @change="load()"></mu-pagination>
            </mu-flex>

        </div>

        <!-- Loading -->
        <mu-loading text="Carregando a lista de grupos" v-if="reports.loading"></mu-loading>

    </div>
</template>

<script>
    import ReportsService from '@/services/services/reports'
    const VUE_APP_STORAGE_REPORTS_PATH = process.env.VUE_APP_STORAGE_REPORTS_PATH

    export default {
        name: 'app-reports-analytical',
        data () {
            return {
                breadcrumbs: [
                    {
                        text: 'Serviços',
                        route: 'app.services',
                        disabled: false
                    },
                    {
                        text: 'Relatórios',
                        route: 'app.services.reports',
                        disabled: false
                    },
                    {
                        text: 'Relatório Analítico',
                        disabled: true
                    }
                ],
                submenu: [
                    {
                        name: 'Criar Relatório',
                        icon: 'add',
                        route: 'app.services.reports.analytical.create',
                        color: 'primary',
                        textColor: null
                    }
                ],
                reports: {
                    loading: false,
                    paging: {
                        page: 1,
                        size: 10,
                        total: 0
                    },
                    columns: [
                        { title: 'Gerado em', name: 'generate_at', width: 220 },
                        { title: 'Empresa', name: 'nick_name' },
                        { title: 'Título', name: 'title' },
                        { title: 'Serviço', name: 'service' },
                        { title: 'Período', name: 'period' },
                        { title: 'Download', name: 'download', align: 'center', width: 180 },
                        { title: 'Status', name: 'status', align: 'center', width: 180 }
                    ],
                    list: []
                },
                refresh: true
            }
        },

        // ╔╦╗╔═╗╦ ╦╔╗╔╔╦╗╔═╗╔╦╗
        // ║║║║ ║║ ║║║║ ║ ║╣  ║║
        // ╩ ╩╚═╝╚═╝╝╚╝ ╩ ╚═╝═╩╝

        mounted  () {
            setInterval(() => {
                if (this.refresh) {
                    this.load(false)
                }
            }, 10000)
        },

        // ╔═╗╦═╗╔═╗╔═╗╔╦╗╔═╗╔╦╗
        // ║  ╠╦╝║╣ ╠═╣ ║ ║╣  ║║
        // ╚═╝╩╚═╚═╝╩ ╩ ╩ ╚═╝═╩╝

        /**
         * Acessamos o load para carregar a lista de grupos assim que
         * o componente é montado
         */
        created () {
            this.load()
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            /**
             * Carrega a lista de grupos passando a paginação
             */
            async load (visible = true) {
                try {
                    if (visible) {
                        this.reports.loading = true
                    }
                    let result = await ReportsService.all({
                        page: this.reports.paging.page
                    })
                    if (result && result.status) {
                        this.reports.paging.page = result.currentPage
                        this.reports.paging.total = result.rowCount
                        this.reports.list = result.results
                        this.checkReportInProcess()
                        return
                    }
                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os dados.')
                } finally {
                    if (visible) {
                        this.reports.loading = false
                    }
                }
            },
            checkReportInProcess () {
                let find = this.reports.list.find((item) => {
                    return item.status === 0 || item.status === 1
                })
                if (find) {
                    this.refresh = true
                } else {
                    this.refresh = false
                }
            },
            async downloadFile (data) {
                window.open(`${VUE_APP_STORAGE_REPORTS_PATH}/${data.id}.xlsx`, '_blank')
                await ReportsService.log({
                    message: `Tipo: ${data.type} , Título: ${data.title} , Serviço: ${data.service}, Período: ${data.start_at} até ${data.end_at} , Empresa: ${data.nick_name}, Id: ${data.company_id}`
                })
            }
        }
    }
</script>

<style lang="stylus" scoped>

    .icon-size
        font-size 16px

    .processed
        color grey

    .alert-message
        padding 20px
        background #e6e6e6
        color #666
        font-size 12px
        strong
            margin-right 5px
            color #333
        .mu-button
            padding-left 10px
            padding-right 10px
            margin-left 10px
        svg
            margin-right 5px
        .legend
            display block
            .mu-dot
                margin-left 5px

    .paginate
        padding 20px

</style>
